import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconAddInfo } from 'src/assets/icons/IconAddInfo';
import { CustomIconButton } from 'src/components/CustomIconButton';
import { CustomTooltip } from 'src/components/CustomTooltip';
import { useIsTranslated } from 'src/lib/hooks';

import { useStyles } from './useStyles';

export const ContinueRowFloatingPanel = ({ className, selectionRect, onAddClick, disabled }) => {
  const styles = useStyles({ selectionRect });

  const isTranslated = useIsTranslated();

  return (
    <span
      className={cx(styles.root, className)}
      data-testid="continueRowFloatingPanel"
    >
      <CustomIconButton
        className={styles.button}
        onClick={onAddClick}
        disabled={disabled || isTranslated}
        data-testid="ShowResourceAndMessagingBankAssetsPopup"
      >
        <CustomTooltip
          classes={{ tooltip: styles.tooltip }}
          title={'Add a web page, file, image, or \na messaging bank asset to this prompt'}
          placement="bottom"
        >
          <IconAddInfo />
        </CustomTooltip>
      </CustomIconButton>
    </span>
  );
};
ContinueRowFloatingPanel.propTypes = {
  className: PropTypes.string,
  selectionRect: PropTypes.shape(),
  onAddClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
ContinueRowFloatingPanel.defaultProps = {
  className: null,
  selectionRect: null,
  disabled: false,
};
